import React from 'react';
import './styles.css';

const Button = ({onPress, customStyle , label}) =>{
    return (
        <div 
            className='button-container' 
            style={{customStyle}}
            onClick={onPress}
        >
            <p className='button-label'>{label}</p>
        </div>
    )
}
export default Button;